const UserEventTypes = Object.freeze({
  RUN_RESET: 'RunReset',
  STARTER_LOADOUT_READY: 'StarterLoadoutReady',
  CONSUME_ITEM: 'ConsumeItem',
  QUICK_BELT_CHANGED: 'QuickBeltChanged',
  HUNGER_PROGRESS: 'HungerProgress',
  BASE_CAMP_CHANGED: 'BaseCampChanged',
  WORLD_INSTANCE_CHANGED: 'WorldInstanceChanged',
  REGION_TRANSITIONED: 'RegionTransitioned',
  RESOURCE_COLLECTION_STARTED: 'ResourceCollectionStarted',
  RESOURCE_COLLECTION_COMPLETED: 'ResourceCollectionCompleted',
});

export default UserEventTypes;
